import { render, staticRenderFns } from "./TuangouView.vue?vue&type=template&id=3ce9de79&scoped=true"
import script from "./TuangouView.vue?vue&type=script&lang=js"
export * from "./TuangouView.vue?vue&type=script&lang=js"
import style0 from "./TuangouView.vue?vue&type=style&index=0&id=3ce9de79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce9de79",
  null
  
)

export default component.exports